module.exports = Em.Mixin.create({
    queryParams: {
        accountId: 'accountId',
        bulkPage: 'bulkPage',
        bulkPageSize: 'bulkPageSize',
        bulkSortDirection: 'bulkSortDirection',
        bulkSortProperty: 'bulkSortProperty',
        bulkUploadType: 'bulkUploadType',
        categoryKey: 'category',
        contactId: 'contactId',
        contactName: 'contactName',
        depositAmount: 'depositAmount',
        depositType: 'depositType',
        drawerMode: 'drawerMode',
        initialRoute: 'initialRoute',
        page: 'page',
        pageSize: 'pageSize',
        period: 'period',
        searchQuery: 'searchQuery',
        sidePanelMode: 'sidePanelMode',
        sortDirection: 'sortDirection',
        sortProperty: 'sortProperty',
        status: 'status',
        type: 'type'
    },

    accountId: null,
    bulkPage: null,
    bulkPageSize: null,
    bulkSortDirection: null,
    bulkSortProperty: null,
    bulkUploadType: null,
    categoryKey: null,
    contactId: null,
    contactName: null,
    depositAmount: null,
    depositType: null,
    drawerMode: null,
    initialRoute: null,
    page: null,
    pageSize: null,
    period: null,
    searchQuery: null,
    sidePanelMode: null,
    sortDirection: null,
    sortProperty: null,
    status: null,
    type: null,

    _customActionsBills: {
        billsInvalidateBill: function(e) {
            var props = e.detail.props || {}
            var billId = props ? props.id : undefined

            if (!billId) {
                return
            }

            Billy.Bill.find(billId).promise.then(function(billInstance) {
                billInstance.unload()
            })
        },

        billsConnectBank: function(event) {
            var bankAccountId = event.detail.bankAccountId

            Billy.Account.findByIdQuery(bankAccountId).promise.then(function(bankAccount) {
                self.transitionToRoute('bank_sync', self.get('activeOrganization'), bankAccount)
            })
        }
    }
})
